import { MetaType, LayoutType } from "../types"
import { actionCreatorGuard, reducerActions, reducerGuard } from "../reducers"

const kind = "seq_logics"

export type SeqLogic = {
  kind: typeof kind
  version: number
  name: string
  logic: string
  layout: LayoutType
  meta: MetaType
}

export const reducerAction = {
  meta: actionCreatorGuard<SeqLogic, MetaType>("meta", kind),
  name: actionCreatorGuard<SeqLogic, string>("name", kind),
  logic: actionCreatorGuard<SeqLogic, string>("logic", kind),
  layout: actionCreatorGuard<SeqLogic, LayoutType>("layout", kind)
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<
    SeqLogic,
    "kind" | "version"
  >]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const seqLogicAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const seqLogicReducer = reducerGuard<SeqLogic>(kind)
  .case(...reducerAction.meta)
  .case(...reducerAction.name)
  .case(...reducerAction.logic)
  .case(...reducerAction.layout)
  .build()
